
        import * as module0 from './controllers/agent_controller.js';import * as module1 from './controllers/copy_controller.js';import * as module2 from './controllers/sidebar_controller.js';import * as module3 from './controllers/toggle_controller.js'
        const modules = {
            "./controllers/agent_controller.js": module0,
            "./controllers/copy_controller.js": module1,
            "./controllers/sidebar_controller.js": module2,
            "./controllers/toggle_controller.js": module3,
        };
        export default modules;
      